import { render, staticRenderFns } from "./SideBarBookings.vue?vue&type=template&id=f048ead2"
import script from "./SideBarBookings.vue?vue&type=script&lang=js"
export * from "./SideBarBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports